import { FC,Dispatch } from 'react';
import { Setting } from '../../App';
import classes from '../../asset/css/subscription-detail/product-list-paused.module.css';
import { ProductInfoViewType } from '../../types/view/product-info-view-type';
import { RecommendProductInfoViewType } from '../../types/view/recommend-product-info-view-type';
import { SummaryViewType } from '../../types/view/summary-view-type';
import { ProductItemPaused } from './ProductItemPaused';

export const ProductListPaused: FC<{
  pausedProducts: ProductInfoViewType[];
  loading: boolean;
  setting: Setting;
  addProductSuccess: (showModal: boolean) => void;
  failed: (message: string) => void;
  setSubscriptionContractId: Dispatch<string>;
  setRegisteredProducts: Dispatch<ProductInfoViewType[]>;
  setPausedProducts: Dispatch<ProductInfoViewType[]>;
  setRecommendProducts: Dispatch<RecommendProductInfoViewType[]>;
}> = ({
  pausedProducts,
  loading,
  setting,
  addProductSuccess,
  failed,
  setSubscriptionContractId,
  setPausedProducts,
  setRecommendProducts,
  setRegisteredProducts,
}) => {
  if (pausedProducts.length === 0) {
    return <></>;
  }

  return (
    <div className={classes.paused}>
      <h2 className={classes.paused_heading}>
        <span className={classes.paused_heading_label}>お届け停止中の商品一覧</span>
      </h2>
      <ul className={classes.paused_list}>
        {pausedProducts.map((product, index) => (
          <ProductItemPaused
            key={`paused_${index}`}
            loading={loading}
            productItem={product}
            setting={setting}
            addProductSuccess={addProductSuccess}
            failed={failed}
            setSubscriptionContractId={setSubscriptionContractId}
            setRegisteredProducts={setRegisteredProducts}
            setPausedProducts={setPausedProducts}
            setRecommendProducts={setRecommendProducts}
          />
        ))}
      </ul>
    </div>
  );
};
